import type {StateCreator} from 'zustand'
import {ViewMode} from '../../components/comments/utils/view-mode'

export type CommentsPanelViewSliceOpts = {
  commentsPanelViewMode?: ViewMode
}

export interface CommentsPanelViewSlice {
  /** Which set of comments the docked comments panel is showing. */
  commentsPanelViewMode: ViewMode
  /** The thread the docked comments panel has open in reply detail, if any. */
  commentsPanelViewActions: {
    setCommentsPanelViewMode: (viewMode: ViewMode) => void
  }
}

export const createCommentsPanelViewSlice =
  ({
    commentsPanelViewMode = ViewMode.ThreadPreviews,
  }: CommentsPanelViewSliceOpts): StateCreator<
    CommentsPanelViewSlice,
    [['zustand/devtools', never]],
    [],
    CommentsPanelViewSlice
  > =>
  set => ({
    commentsPanelViewMode,
    commentsPanelViewActions: {
      setCommentsPanelViewMode: viewMode => {
        set(
          {
            commentsPanelViewMode: viewMode,
          },
          undefined,
          'setCommentsPanelViewMode',
        )
      },
    },
  })
